import sdl from '@jds/react-generated-sdl/JDSProgressBar';
import type { JDSProgressBarProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, ProgressBarProps } from '../logic';

const Component = (props: ProgressBarProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'determinate',
    labelPosition = 'stretch',
    state = 'undefined',
    ariaLabel = props.label?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { kind, labelPosition, state, ariaLabel, ...rest },
    'JDSProgressBar',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const ProgressBar = withLogic(Component) as React.FC<ProgressBarProps> & {
  slotName?: string;
};

ProgressBar.displayName = 'ProgressBar';
ProgressBar.slotName = 'jds_progress_bar';

export { ProgressBar, type JDSProgressBarProps };
